module.exports = __webpack_public_path__ + "static/media/lock-closed.0af1e364.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/svg/lock-closed.svg
// module id = 3840
// module chunks = 0